import { useEffect, useState } from "react";

const navLinks = [
  { id: "offerings", label: "内容方向" },
  { id: "library", label: "影片库" },
  { id: "nineties", label: "九十年代" },
  { id: "theater", label: "怀旧剧场" },
  { id: "watch", label: "观影指南" },
  { id: "faq", label: "影迷问答" },
];

export default function SiteNav() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const solid = scrolled || menuOpen;

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 ${
        solid
          ? "bg-background-50/95 backdrop-blur border-b border-background-200"
          : "bg-transparent"
      }`}
    >
      <nav className="w-full px-4 md:px-8">
        <div className="h-16 md:h-20 flex items-center justify-between">
          <a href="#top" className="flex items-center gap-3">
            <span className="w-10 h-10 rounded-md bg-primary-500 text-background-50 flex items-center justify-center">
              <i className="ri-film-line text-xl" />
            </span>
            <span
              className={`font-heading text-lg md:text-xl font-700 tracking-wide ${
                solid ? "text-foreground-950" : "text-background-50"
              }`}
            >
              九七电影院
            </span>
          </a>

          <div className="hidden lg:flex items-center gap-1">
            {navLinks.map((link) => (
              <a
                key={link.id}
                href={`#${link.id}`}
                className={`px-3 py-2 rounded-md text-sm font-label whitespace-nowrap transition-colors ${
                  solid
                    ? "text-foreground-700 hover:text-primary-600 hover:bg-primary-50"
                    : "text-background-100 hover:text-accent-100 hover:bg-background-50/10"
                }`}
              >
                {link.label}
              </a>
            ))}
            <a
              href="#library"
              className="ml-3 inline-flex items-center gap-2 px-4 py-2 rounded-md bg-primary-500 text-background-50 text-sm font-label whitespace-nowrap hover:bg-primary-600 transition-colors"
            >
              <i className="ri-play-circle-line text-base" />
              开始浏览
            </a>
          </div>

          <button
            type="button"
            aria-label="打开导航菜单"
            aria-expanded={menuOpen}
            onClick={() => setMenuOpen((v) => !v)}
            className={`lg:hidden w-10 h-10 flex items-center justify-center rounded-md ${
              solid ? "text-foreground-900" : "text-background-50"
            }`}
          >
            <i className={`${menuOpen ? "ri-close-line" : "ri-menu-line"} text-2xl`} />
          </button>
        </div>
      </nav>

      {menuOpen && (
        <div className="lg:hidden border-t border-background-200 bg-background-50 px-4 py-3">
          <div className="flex flex-col">
            {navLinks.map((link) => (
              <a
                key={link.id}
                href={`#${link.id}`}
                onClick={() => setMenuOpen(false)}
                className="px-2 py-3 text-sm text-foreground-700 border-b border-background-100 last:border-0"
              >
                {link.label}
              </a>
            ))}
            <a
              href="#library"
              onClick={() => setMenuOpen(false)}
              className="mt-3 inline-flex items-center justify-center gap-2 px-4 py-3 rounded-md bg-primary-500 text-background-50 text-sm font-label"
            >
              <i className="ri-play-circle-line text-base" />
              开始浏览
            </a>
          </div>
        </div>
      )}
    </header>
  );
}